import { NgIf } from '@angular/common';
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BmiCalculatorComponent } from '@components/bmi-calculator/bmi-calculator.component';
import { CardComponent } from '@components/card/card.component';
import { ConsultationRequestAddressComponent } from '@components/consultation-request/consultation-request-address/consultation-request-address.component';
import { ConsultationRequestFormComponent } from '@components/consultation-request/consultation-request-form/consultation-request-form.component';
import { ConsultationRequestPatientInfoComponent } from '@components/consultation-request/consultation-request-patient-info/consultation-request-patient-info.component';
import { LabFinderModalComponent } from '@components/consultation-request/lab-finder-modal/lab-finder-modal.component';
import { MedicalHistoryQuestionsComponent } from '@components/consultation-request/medical-history-questions/medical-history-questions.component';
import { ConsultationRequestHeaderComponent } from '@components/consultation-request-header/consultation-request-header.component';
import { DynamicQuestionnaireFormComponent } from '@components/dynamic-forms/dynamic-questionnaire-form/dynamic-questionnaire-form.component';
import { ErrorNotificationComponent } from '@components/error-notification/error-notification.component';
import { ConsultationStatus } from '@enums/consultation-status';
@Component({
  selector: 'app-glp1-consultation-request-form',
  templateUrl: 'glp1-consultation-request-form.component.html',
  styleUrls: ['glp1-consultation-request-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    NgIf,
    ErrorNotificationComponent,
    ConsultationRequestHeaderComponent,
    ConsultationRequestPatientInfoComponent,
    CardComponent,
    DynamicQuestionnaireFormComponent,
    MedicalHistoryQuestionsComponent,
    BmiCalculatorComponent,
    ConsultationRequestAddressComponent,
    LabFinderModalComponent,
  ],
})
export class Glp1ConsultationRequestFormComponent extends ConsultationRequestFormComponent {
  @ViewChild('bmiCalculatorComponent', { static: false }) private bmiCalculatorComponent: BmiCalculatorComponent;
  @ViewChild('upsellQuestionsForm', { static: false }) private upsellQuestionsForm: DynamicQuestionnaireFormComponent;

  /**
   * Gets the upsell questions form.
   */
  private get upsellForm(): FormGroup {
    return this.upsellQuestionsForm?.form;
  }

  /**
   * Return true if the BMI calculator is present and disqualified.
   */
  private get isBmiCalculatorDisqualified() {
    return this.bmiCalculatorComponent && this.bmiCalculatorComponent.disqualified;
  }

  /**
   * {@inheritDoc}
   * Adds touching BMI component form.
   */
  protected override markAllFormControlsAsTouched(): void {
    super.markAllFormControlsAsTouched();
    this.bmiCalculatorComponent?.form.markAllAsTouched();
    this.upsellForm?.markAllAsTouched();
  }

  /**
   * {@inheritDoc}
   * Adds check for BMI disqualification.
   */
  protected override getConsultationStatus(): ConsultationStatus {
    return this.isBmiCalculatorDisqualified ? ConsultationStatus.Disqualified : super.getConsultationStatus();
  }

  /**
   * {@inheritDoc}
   * Adds check for upsell form validity.
   */
  protected override areFormsValid(): boolean {
    return super.areFormsValid() && !this.upsellForm?.invalid;
  }

  /**
   * {@inheritDoc}
   * Check if forms are touched, including the upsell form.
   */
  protected override areFormsTouched(): boolean {
    return super.areFormsTouched() && this.upsellForm?.touched;
  }
}
